import Loading from "@/components/widgets/Loading.vue"
import Vue from "vue"
import Drawer from '@/components/drawers'
import VueSimpleSuggest from "vue-simple-suggest"

export default {
  props: {
    opened: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Loading,
    Drawer,
    VueSimpleSuggest,
  },
  data() {
    return {
      loading: false,
      drawerOpened: false,
      itemOptions: [],     // สินค้าในคลังสาขา (มี stock)
      picker: { label: "" },
      lines: [],           // รายการที่เลือกนำออก
      // ร่างที่สร้างแล้วแต่ confirm ไม่ผ่าน — กดซ้ำให้ confirm ใบเดิม ไม่สร้างร่างซ้ำ
      draftUuid: null,
      draftSignature: null,
      form: {
        reason: null,
        remark: null,
      },
    }
  },
  computed: {
    totalQty() {
      // รวมเป็นหน่วยเล็กสุดเสมอ (แต่ละบรรทัดอาจกรอกคนละหน่วย บวกกันตรง ๆ ไม่ได้)
      return this.lines.reduce((s, l) => s + this.lineBaseQty(l), 0)
    },
    canSubmit() {
      if (!this.form.reason) return false
      if (this.lines.length === 0) return false
      return this.lines.every(l => l.quantity > 0 && this.lineBaseQty(l) <= l.available)
    },
  },
  watch: {
    opened(n) {
      if (n) {
        this.drawerOpened = true
        this.resetForm()
        this.loadItemOptions()
      }
    }
  },
  methods: {
    onCloseDrawer() {
      this.drawerOpened = false
      this.resetForm()
      this.$emit('close-event', { status: true })
    },
    resetForm() {
      this.draftUuid = null
      this.draftSignature = null
      this.lines = []
      this.picker.label = ""
      this.form.reason = null
      this.form.remark = null
    },
    // โหลดสินค้าในคลังสาขา (เฉพาะที่มียอดคงเหลือ)
    async loadItemOptions() {
      try {
        // per_page ใหญ่ — เดิมได้แค่หน้าแรก 8 แถว สินค้าที่เหลือเบิกไม่ได้
        const url = `${Vue.prototype.$host}/api/v1/miscellaneous?page=1&keyword=&isBranchStock=true&per_page=500&sort_by=name&sort_desc=false`
        const res = await Vue.prototype.$axios.get(url)
        const rows = res?.data?.data || []
        this.itemOptions = rows.map(r => ({
          sku_id: r.sku_id,
          code: r.code,
          name: r.name,
          unit_name: r.unit_name,
          qualtity: parseFloat(r.qualtity) || 0,
          label: `${r.code || ''} ${r.name || ''}`.trim(),
          // ตัวแปลงหน่วยใหญ่จาก master SKU (เบิกเป็นลัง/กล่องได้ ระบบแปลงเป็นหน่วยเล็กสุด)
          unit_conversions: ((r.sku && r.sku.unit_conversions) || []).map(c => ({
            id: c.unit_id,
            name: (c.unit && c.unit.name) ? c.unit.name : ('หน่วย #' + c.unit_id),
            base_qty: parseFloat(c.base_qty),
          })),
        }))
      } catch (error) {
        this.onExceptionHandler(error?.response?.data?.message || 'โหลดสินค้าไม่สำเร็จ')
      }
    },
    onPickItem(sel) {
      if (!sel || !sel.sku_id) return
      // กันเลือกซ้ำ
      if (this.lines.some(l => l.sku_id === sel.sku_id)) {
        this.picker.label = ""
        return
      }
      this.lines.push({
        sku_id: sel.sku_id,
        code: sel.code,
        name: sel.name,
        unit_name: sel.unit_name,
        available: sel.qualtity,
        quantity: 1,
        input_unit_id: null, // null = หน่วยเล็กสุด
        unit_choices: [{ id: null, name: sel.unit_name || 'หน่วยเล็กสุด' }].concat(sel.unit_conversions || []),
      })
      this.picker.label = ""
    },
    // จำนวนในหน่วยเล็กสุดของบรรทัดนี้ (ตามหน่วยที่เลือกกรอก)
    lineBaseQty(l) {
      const qty = parseFloat(l.quantity) || 0
      if (!l.input_unit_id) return qty
      const c = (l.unit_choices || []).find(x => x.id === l.input_unit_id)
      return c && c.base_qty ? qty * c.base_qty : qty
    },
    removeLine(idx) {
      this.lines.splice(idx, 1)
    },
    async onSubmit(confirmNow) {
      if (!this.canSubmit) return
      try {
        this.loading = true

        // 1) สร้างเอกสารร่าง
        const payload = {
          reason: this.form.reason,
          remark: this.form.remark,
          items: this.lines.map(l => ({ sku_id: l.sku_id, quantity: l.quantity, input_unit_id: l.input_unit_id })),
        }
        // ถ้ามีร่างจากรอบก่อน (confirm ไม่ผ่าน) และรายการไม่เปลี่ยน → ใช้ร่างเดิม
        const signature = JSON.stringify(payload)
        let uuid = null
        let message = 'บันทึกใบนำออกเรียบร้อยแล้ว'
        if (this.draftUuid && this.draftSignature === signature) {
          uuid = this.draftUuid
        } else {
          const created = await Vue.prototype.$axios.post(
            `${Vue.prototype.$host}/api/v1/stock-issues`, payload
          )
          uuid = created?.data?.uuid
          message = created?.data?.message || message
          this.draftUuid = uuid || null
          this.draftSignature = signature
        }

        // 2) ถ้ายืนยันเลย -> เรียก confirm
        if (confirmNow && uuid) {
          try {
            const confirmed = await Vue.prototype.$axios.post(
              `${Vue.prototype.$host}/api/v1/stock-issues/${uuid}/confirm`
            )
            message = confirmed?.data?.message || 'ยืนยันนำออกสำเร็จ'
          } catch (error) {
            // ร่างถูกบันทึกแล้ว — เก็บ draftUuid ไว้ กดยืนยันอีกครั้งจะ confirm ใบเดิม
            this.loading = false
            this.onExceptionHandler('บันทึกร่างแล้วแต่ยืนยันไม่สำเร็จ: ' + (error?.response?.data?.message || 'กรุณากดยืนยันอีกครั้ง'))
            return
          }
        }

        this.loading = false
        this.$swal({
          width: "29rem",
          padding: '1.825em',
          html: '<div class="d-flex flex-row align-items-center">' +
            '<i class="fa fa-2x mr-3 fa-check-circle text-success"></i>' +
            '<div class="d-flex flex-column">' +
            '<span class="font-bold text-base py-2.5 text-left">สำเร็จ</span>' +
            `<span class="text-base text-left text-gray-500">${message}</span>` +
            '</div></div>',
          allowOutsideClick: false,
          focusConfirm: false,
          customClass: {
            popup: 'swal2-custom-rounded',
            actions: 'justify-content-end',
            title: 'd-none',
            confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
          },
          showCancelButton: false,
          confirmButtonText: "ตกลง",
          showCloseButton: true,
        }).then(() => {
          this.onCloseDrawer()
        })
      } catch (error) {
        this.loading = false
        this.onExceptionHandler(error?.response?.data?.message || 'ไม่สามารถนำออกได้')
      }
    },
  },
}
